export default "__VITE_ASSET__CY9$XnCd__"